import { AnyAction } from 'redux';
import { EDIT_INVESTMENT_ERROR_DETAILS, EDIT_INVESTMENT_VALUE_DETAILS, INITIAL_DATA, REMOVE_INVESTMENT_DATA } from '../types/investmentdetails';

const initState = {
    value: {
        0: {
            schemeId: '',
            lumpsum: {
                lumpAmount: '',
            },
            sip: {
                sipamount: '',
                periods: '',
                installments: '',
                sipDate: '',
                mandate: '',
                sipFolio: '',
            }
        }
    },
    error: {
        0: {
            schemeId: '',
            lumpsum: {
                lumpAmount: '',
            },
            sip: {
                sipamount: '',
                periods: '',
                installments: '',
                sipDate: '',
                mandate: '',
                sipFolio: '',
            }
        }
    }
};
function investmentDetailsReducer(state = initState, action: AnyAction) {
    switch (action.type) {
        case EDIT_INVESTMENT_VALUE_DETAILS: {
            return {
                ...state,
                value: action.body
            };
        }
        case EDIT_INVESTMENT_ERROR_DETAILS: {
            return {
                ...state,
                error: action.body
            };
        }
        case REMOVE_INVESTMENT_DATA: {
            return {
                ...action.body,
            };
        }
        case INITIAL_DATA: {
            return {
                ...state,
                value: { ...initState.value },
                error: { ...initState.value }
            };
        }
        default:
            return state;
    }
}

export default investmentDetailsReducer;
